module.exports = __webpack_public_path__ + "img/award-5.f600864c.jpg";